import './FontScaleStepper.scss';
import React from 'react';
import clsx from 'clsx';
import { MdTextDecrease, MdTextIncrease } from 'react-icons/md';
import Tooltip from '@srm/ui/tooltip';
import { IFontScale } from '../hooks/useFontScale';

type IProps = IFontScale;

/**
 * Степпер размера текста таблиц «Выбора победителя»: «[A−] · 110% · [A+]».
 * Живёт в выпадайке «Пользовательские настройки» (навбар), значение через
 * useFontScale/localStorage синхронизируется с открытыми таблицами. Кнопки —
 * цельные семантические иконки «уменьшить/увеличить текст» (Material
 * text_decrease / text_increase). Клик по проценту сбрасывает масштаб к 100%.
 * Сам контрол не масштабируется (фиксированный размер), чтобы не «прыгал».
 */
export const FontScaleStepper: React.FC<IProps> = ({
    percent,
    increase,
    decrease,
    reset,
    canIncrease,
    canDecrease,
}) => (
    <div className="ws-fontscale" role="group" aria-label="Размер текста">
        <Tooltip openDelay={200} background="black" position="bottom" label="Мельче">
            <button
                type="button"
                className="ws-fontscale__btn"
                onClick={decrease}
                disabled={!canDecrease}
                aria-label="Уменьшить размер текста"
            >
                <MdTextDecrease size="18px" />
            </button>
        </Tooltip>
        <Tooltip openDelay={200} background="black" position="bottom" label="Сбросить к 100%">
            <button
                type="button"
                className={clsx('ws-fontscale__val', { 'ws-fontscale__val--active': percent !== 100 })}
                onClick={reset}
                aria-label={`Размер текста ${percent}%. Нажмите, чтобы сбросить к 100%`}
            >
                {percent}%
            </button>
        </Tooltip>
        <Tooltip openDelay={200} background="black" position="bottom" label="Крупнее">
            <button
                type="button"
                className="ws-fontscale__btn"
                onClick={increase}
                disabled={!canIncrease}
                aria-label="Увеличить размер текста"
            >
                <MdTextIncrease size="18px" />
            </button>
        </Tooltip>
    </div>
);
